import Layers3 from 'lucide-react/dist/esm/icons/layers-3.mjs'
import { contentTypeLabels, platformMeta } from '../utils/formatters'
import { PlatformIcon } from './PlatformIcon'

export function ContentTemplateIdentity({ template, productName, skuName, meta, variant = 'default', action = null, showPlatforms = false }) {
  const binding = meta || [productName, skuName].filter(Boolean).join(' · ') || '未关联产品 SKU'
  return <div className={`content-template-identity ${variant} type-${template?.type || 'image'}`}>
    <span className="content-template-type-icon"><Layers3 size={18}/></span>
    <div className="content-template-identity-copy"><em>{contentTypeLabels[template?.type] || '内容模板'}</em><b>{template?.name || '模板已移除'}</b><small>{binding}</small>{showPlatforms ? <span className="content-template-platforms">{(template?.platforms || []).map(platform => <i key={platform}><PlatformIcon platform={platform} small/>{platformMeta[platform]?.label}</i>)}</span> : null}</div>
    {action ? <div className="content-template-identity-action">{action}</div> : null}
  </div>
}
